<template>
  <div class="community-discount">
    <h1>Community Discount for {{ headerName }}</h1>

    <b-table :data="tableData">
      <b-table-column field="discount_type"
                      label="Discount Type"
                      v-slot="props">
        {{ props.row.discount_type }}
      </b-table-column>
      <b-table-column field="expiration"
                      label="Expiration"
                      numeric
                      v-slot="props">
        {{ props.row.expiration }}
      </b-table-column>
    </b-table>

  </div>
</template>

<script>
export default {
    name: 'CommunityDiscount',
    data() {
        return {
            inited: false,
            communityDiscount: {},
            tableData: [],
        }
    },
    computed: {
        headerName: function() {
            if (! this.$store.state.user.uuid) {
                return ""
            }
            let name = this.$store.state.user.display_name
            if (this.communityDiscount.customer_number) {
                return name + " #" + this.communityDiscount.customer_number
            }
            return name
        },
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // is someone logged in?
            if (this.$store.state.user.uuid) {
                // go ahead and fetch data if it's a member
                if (this.$store.state.user.member) {
                    this.fetchData()
                } else { // send non-members back to "home" page
                    this.$router.push('/benefits')
                }
            } else { // send logged-out users to "login" instead
                this.$router.push('/login')
            }

            // we did it!
            this.inited = true
        },

        fetchData() {
            this.$http.get('/api/my/community-discount').then(response => {
                if (response.data.error) {
                    // TODO: should be smarter than just knee-jerk redirect?
                    this.$router.push('/benefits')
                } else {
                    this.communityDiscount = response.data
                    this.tableData = [
                        {'discount_type': this.communityDiscount.community_discount_type,
                         'expiration': this.communityDiscount.community_discount_expires},
                    ]
                }
            }, response => {
                // TODO: should be smarter than just knee-jerk redirect?
                this.$router.push('/benefits')
            })
        },
    },
}
</script>
